import { useDispatch } from "react-redux";
import { useLazyUpdateProfileQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import useGetAccountApi from "../Account/getAccountApi";

const useUpdateProfile = () => {
  const dispatch = useDispatch();
  const [updateProfile] = useLazyUpdateProfileQuery();
  const getAccountApi = useGetAccountApi();

  const send = (data) => {
    dispatch(setLoader(true));
    updateProfile(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success update profile", "success");
        getAccountApi.get();
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error update profile", "error");
      });
  };
  return {
    send,
  };
};

export default useUpdateProfile;
